<template>
  <div>
    <v-container style="max-width:800px;">
      <v-card>
        <v-container>
          <v-card-actions>
            <v-btn text to="/"><v-icon>mdi-arrow-left-thin</v-icon>戻る</v-btn>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="logout">ログアウト</v-btn>
          </v-card-actions>
          <v-card-title>マイページ</v-card-title>
          <v-form ref="formProfile" v-model="valid" lazy-validation>
            <v-container>
              <p class="mb-1">ユーザーID</p>
              <v-text-field v-model="profile.user_id" dense solo readonly hide-details></v-text-field>
              <p class="mt-2 mb-1">メールアドレス</p>
              <v-text-field v-model="profile.mail_address" dense solo readonly hide-details></v-text-field>
              <p class="mt-2 mb-1">電話番号</p>
              <v-row>
                <v-col cols="8"><v-text-field v-model="sms_tell_number" :disabled='profile.tell_number!=""||otp_lock' dense solo placeholder="0123456789"></v-text-field></v-col>
                <v-col cols="4"><v-btn v-if="profile.tell_number==''" :loading="verifyLoading" :disabled="profile.tell_number!=''||otp_lock||disabled_sms" solo color="primary" @click="sendCode">認証</v-btn></v-col>
              </v-row>
              <div v-if="otp_lock">
                <div class="ma-auto" style="max-width: 300px"><v-otp-input v-model="otp" length="6"></v-otp-input></div>
                <v-btn block color="primary" :disabled="!otp_lock" @click="verifyOTP">送信</v-btn>
              </div>
              <p class="mt-5 mb-1">ポイント</p>
              <v-row class="mb-1">
                <v-col><v-btn color="#bf9507" small elevation="0" class="mr-2 px-2" style="text-transform: none"><span style="color:white;">{{$store.getters.userData?.points}} pt</span></v-btn></v-col>
                <!--<v-col><v-btn color="#0086D2" small elevation="0" class="mr-1 px-2" style="text-transform: none"><span style="color:white;">{{$store.getters.userData?.ap}} ap</span></v-btn></v-col>-->
              </v-row>
              <v-divider></v-divider>
              <p class="mt-2 mb-1">氏名*</p>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="profile.last_name" :rules="[rules.required,rules.counter20]" dense solo label="姓" placeholder="山田"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="profile.first_name" :rules="[rules.required,rules.counter20]" dense solo label="名" placeholder="太郎"></v-text-field>
                </v-col>
              </v-row>
              <p class="mb-1">フリガナ*</p>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="profile.last_name_kana" :rules="[rules.required,rules.counter20]" dense solo label="セイ" placeholder="ヤマダ"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="profile.first_name_kana" :rules="[rules.required,rules.counter20]" dense solo label="メイ" placeholder="タロウ"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <p class="mb-1">郵便番号*</p>
                  <v-text-field v-model="profile.post_code" :rules="[rules.required,rules.postCode]" dense solo placeholder="0000000"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <p class="mb-1">都道府県*</p>
                  <v-select v-model="profile.prefectures" :rules="[rules.required]" :items="items_prefectures" dense solo></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <p class="mb-1">市区町村*</p>
                  <v-text-field v-model="profile.municipalities" :rules="[rules.required,rules.counter20]" dense solo></v-text-field>
                </v-col>
                <v-col cols="6">
                  <p class="mb-1">番地*</p>
                  <v-text-field v-model="profile.address" :rules="[rules.required,rules.counter20]" dense solo></v-text-field>
                </v-col>
              </v-row>
              <p class="mb-1">建物名</p>
              <v-text-field v-model="profile.building" :rules="[rules.counter50]" dense solo></v-text-field>
              <p class="grey--text text-right">*は必須項目です</p>
              <v-btn :disabled="isDisabled" block @click="saveProfile" color="#004B78" class="white--text">登録する</v-btn>
            </v-container>
          </v-form>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from '../store'
import Api from '@/modules/api'

export default {
  name: 'profile',
  data(){
    return{
      isDisabled: false,
      valid: true,
      items_prefectures: [
        "北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県",
        "茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県",
        "新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県",
        "静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県",
        "奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県",
        "徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県",
        "熊本県","大分県","宮崎県","鹿児島県","沖縄県"
      ],
      rules: {
        required: value => !!value || '必須項目です.',
        counter20: value => value.length <= 20 || '20文字以内で入力してください.',
        counter50: value => value.length <= 50 || '50文字以内で入力してください.',
        tellNumber: value => {
          const pattern = /^(0{1}\d{9,10})$/
          return pattern.test(value) || '無効な電話番号です.'
        },
        postCode: value => {
          const pattern = /^\d{7}$/
          return pattern.test(value) || '無効な郵便番号です.'
        },
      },
      verifyLoading: false,
      sms_tell_number: '',
      otp: '',
      otp_id: '',
      otp_lock: false,
      disabled_sms: false,
    }
  },
  computed: {
    profile: function(){
      if(store.getters.userData == null){
        return {
          mail_address: '',
          first_name: '',
          last_name: '',
          first_name_kana: '',
          last_name_kana: '',
          tell_number: '',
          post_code: '',
          prefectures: '',
          municipalities: '',
          address: '',
          building: '',
        }
      }
      this.changeTellNumber()
      console.info(store.getters.userData)
      return store.getters.userData
    },
  },
  methods: {
    ...mapActions(["openSnackbar", "closeSnackbar"]),
    logout: function(){
      this.$cognito.signout()
      this.$store.commit('setUser',null)
      this.$store.commit('setUserData',null)
      this.$store.commit('setMyCards',null)
      this.$store.commit('setJwtToken',null)
      this.$router.push({path: '/'})
      this.$router.go(0)
    },
    changeTellNumber: function(){
      this.sms_tell_number = store.getters.userData.tell_number
    },
    saveProfile: function(){
      this.isDisabled = true
      setTimeout(() => {
        this.isDisabled = false
      }, 2000)
      if(this.$refs.formProfile.validate()){
        Api.putUser(this.profile).then(res => {
          console.log(res);
          Api.getUser()
          this.openSnackbar("プロフィールを更新しました!")
        }).catch(() => {
          this.openSnackbar("プロフィールの更新に失敗しました")
        })
      }else{
        this.openSnackbar("入力に不備があります")
      }
    },
    sendCode: function(){
      const phone_number = this.sms_tell_number
      Api.postSmsCreateCode(phone_number).then(res => {
        console.log(res);
        this.otp_lock = true
        this.otp_id = res.data.id
        this.openSnackbar("認証コードを送信しました!")
      }).catch(err => {
        console.log(err)
        this.disabled_sms = true
        setTimeout(() => {this.disabled_sms = false}, 5000)
        if(err.response?.status == 400){
          if(err.response.data == 'AlreadyUsed') this.openSnackbar('この電話番号は既に使用されています')
        }else{
          this.openSnackbar("認証コードの送信に失敗しました")
        }
      })
    },
    verifyOTP: function(){
      const otp = this.otp
      const id = this.otp_id
      const phone_number = this.sms_tell_number
      Api.postSmsVerifyCode(id,otp,phone_number).then(res => {
        console.log(res)
        console.log(res.data.valid)
        this.otp = ''
        this.otp_lock = false
        if(res.data.valid){
          this.openSnackbar("認証に成功しました")
        }else{
          this.openSnackbar("認証に失敗しました")
        }
      }).catch(err => {
        console.log(err)
        this.otp = ''
        this.otp_lock = false
        this.openSnackbar("認証中にエラーが発生しました")
      })
    },
  },
}
</script>

<style scoped>
.noisy-back {
  min-height: 100vh;
  background-color:#004B78;
  background-image: url(data:image/png;base64,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);  
  background-repeat: repeat;
} 
</style>

